<template>

  <div class="workspace-orcamentos-page workspace-orcamentos-editor">

    <div class="modern-header">

      <div class="header-container">

        <div class="breadcrumb-section">

          <nav class="breadcrumb">

            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">{{ t('common.breadcrumb.dashboard') }}</button>

            <span class="breadcrumb-separator">/</span>

            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}/orcamentos`)">{{ t('orcamentos.list.breadcrumb') }}</button>

            <span class="breadcrumb-separator">/</span>

            <span class="breadcrumb-current">{{ isNew ? t('orcamentos.editor.new') : t('orcamentos.editor.edit') }}</span>

          </nav>

        </div>

        <div class="title-section">

          <div class="title-content">

            <div class="title-icon title-icon--crm">

              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

                <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>

              </svg>

            </div>

            <div class="title-text">

              <h1 class="main-title">{{ isNew ? t('orcamentos.editor.new') : (form.titulo || t('orcamentos.list.untitled')) }}</h1>

              <p class="subtitle">{{ t('orcamentos.editor.subtitle') }}</p>

            </div>

          </div>

          <div class="workspace-badge type-crm">

            <div class="badge-icon">

              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>

              </svg>

            </div>

            <span class="badge-text">CRM</span>

          </div>

        </div>

        <div class="actions-section">

          <div class="actions-left" />

          <div class="actions-right">

            <button type="button" class="action-button secondary" :disabled="saving" @click="salvar">{{ t('orcamentos.editor.saveDraft') }}</button>

            <button type="button" class="action-button secondary" :disabled="saving || publishing" @click="publicar">{{ t('orcamentos.editor.generate') }}</button>

            <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/orcamentos`)">

              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/></svg>

              {{ t('orcamentos.list.back') }}

            </button>

          </div>

        </div>

      </div>

    </div>



    <div class="orc-page-content orc-editor-page">

      <div class="orc-editor-layout">

        <div class="orc-editor-form">

          <section class="orc-form-section">

            <header class="orc-form-section__head">

              <div class="orc-form-section__icon orc-form-section__icon--geral">

                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>

              </div>

              <div>

                <h2>{{ t('orcamentos.editor.sectionGeral') }}</h2>

                <p>{{ t('orcamentos.editor.sectionGeralSub') }}</p>

              </div>

            </header>

            <div class="orc-form-grid">

              <label class="orc-form-field orc-form-field--full">

                <span>{{ t('orcamentos.editor.titulo') }}</span>

                <input v-model="form.titulo" type="text" :placeholder="t('orcamentos.editor.tituloPh')" />

              </label>

              <label class="orc-form-field">

                <span>{{ t('orcamentos.editor.validadeDias') }}</span>

                <div class="orc-form-qty-wrap">
                  <button
                    type="button"
                    class="orc-form-qty-step"
                    :disabled="(Number(form.validadeDias) || 1) <= 1"
                    @click="bumpValidadeDias(-1)"
                  >
                    −
                  </button>
                  <input
                    v-model.number="form.validadeDias"
                    type="number"
                    min="1"
                    max="365"
                    class="orc-form-qty-input"
                  >
                  <button
                    type="button"
                    class="orc-form-qty-step"
                    :disabled="(Number(form.validadeDias) || 1) >= 365"
                    @click="bumpValidadeDias(1)"
                  >
                    +
                  </button>
                  <span class="orc-form-qty-suffix">{{ t('orcamentos.config.daysSuffix') }}</span>
                </div>

              </label>

              <div v-if="leadInfo" class="orc-lead-chip orc-form-field--full">

                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>

                <span>{{ t('orcamentos.editor.leadLinked') }}: <strong>{{ leadInfo.nome }}</strong></span>

              </div>

            </div>

          </section>



          <section class="orc-form-section">

            <header class="orc-form-section__head orc-form-section__head--tools">

              <div class="orc-form-section__icon orc-form-section__icon--items">

                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/></svg>

              </div>

              <div class="orc-form-section__head-text">

                <h2>{{ t('orcamentos.editor.servicos') }}</h2>

                <p>{{ t('orcamentos.editor.sectionItemsSub') }}</p>

              </div>

              <div class="orc-form-section__tools">

                <div
                  v-if="templates.length"
                  ref="catalogPickerRef"
                  class="orc-catalog-picker"
                  :class="{ 'orc-catalog-picker--open': catalogOpen }"
                >
                  <button
                    type="button"
                    class="orc-catalog-picker__trigger"
                    :aria-expanded="catalogOpen"
                    aria-haspopup="listbox"
                    @click.stop="toggleCatalogPicker"
                  >
                    <span class="orc-catalog-picker__icon" aria-hidden="true">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                      </svg>
                    </span>
                    <span class="orc-catalog-picker__copy">
                      <span class="orc-catalog-picker__label">{{ t('orcamentos.editor.catalogPickerLabel') }}</span>
                      <span class="orc-catalog-picker__hint">{{ t('orcamentos.editor.catalogPickerHint') }}</span>
                    </span>
                    <span class="orc-catalog-picker__badge">{{ templates.length }}</span>
                    <svg class="orc-catalog-picker__chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                    </svg>
                  </button>

                  <Transition name="orc-catalog-fade">
                    <div
                      v-if="catalogOpen"
                      class="orc-catalog-picker__menu"
                      role="listbox"
                      :aria-label="t('orcamentos.editor.catalogPickerLabel')"
                    >
                      <p class="orc-catalog-picker__menu-title">{{ t('orcamentos.editor.catalogPickerMenuTitle') }}</p>
                      <ul class="orc-catalog-picker__list">
                        <li v-for="tpl in templates" :key="tpl.id" class="orc-catalog-picker__item">
                          <button
                            type="button"
                            class="orc-catalog-picker__option"
                            role="option"
                            @click="pickTemplate(tpl)"
                          >
                            <span class="orc-catalog-picker__option-main">
                              <span class="orc-catalog-picker__option-name">{{ tpl.nome }}</span>
                              <span class="orc-catalog-picker__option-price">{{ formatMoney(tpl.valor) }}</span>
                            </span>
                            <span v-if="tpl.descricao" class="orc-catalog-picker__option-desc">{{ tpl.descricao }}</span>
                          </button>
                          <button
                            type="button"
                            class="orc-catalog-picker__remove"
                            :title="t('orcamentos.editor.removeFromCatalog')"
                            :aria-label="t('orcamentos.editor.removeFromCatalog')"
                            :disabled="catalogDeletingId === tpl.id"
                            @click.stop="removerDoCatalogo(tpl)"
                          >
                            <svg v-if="catalogDeletingId !== tpl.id" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                            </svg>
                            <span v-else class="orc-catalog-picker__remove-spinner" aria-hidden="true" />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </Transition>
                </div>

                <button type="button" class="orc-btn orc-btn--primary orc-btn--sm" @click="addItem">

                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>

                  {{ t('orcamentos.editor.addItem') }}

                </button>

              </div>

            </header>



            <div class="orc-items-list">

              <article v-for="(item, idx) in form.itens" :key="idx" class="orc-item-card">

                <div class="orc-item-card__badge">{{ idx + 1 }}</div>

                <div class="orc-item-card__body">

                  <div class="orc-form-grid orc-form-grid--item">

                    <label class="orc-form-field">

                      <span>{{ t('orcamentos.editor.itemNome') }}</span>

                      <input v-model="item.nome" type="text" :placeholder="t('orcamentos.editor.itemNomePh')" />

                    </label>

                    <label class="orc-form-field">

                      <span>{{ t('orcamentos.editor.itemValor') }}</span>

                      <input v-model.number="item.valor" type="number" min="0" step="0.01" class="orc-input-money" />

                    </label>

                    <label class="orc-form-field orc-form-field--full">

                      <span>{{ t('orcamentos.editor.itemDesc') }}</span>

                      <textarea v-model="item.descricao" rows="2" :placeholder="t('orcamentos.editor.itemDescPh')" />

                    </label>

                  </div>

                  <div class="orc-item-card__actions">

                    <button type="button" class="orc-btn orc-btn--ghost orc-btn--sm" @click="salvarNoCatalogo(item)">{{ t('orcamentos.editor.saveCatalog') }}</button>

                    <button type="button" class="orc-btn orc-btn--danger orc-btn--sm" :disabled="form.itens.length <= 1" @click="removeItem(idx)">{{ t('orcamentos.editor.removeItem') }}</button>

                  </div>

                </div>

              </article>

            </div>



            <div class="orc-form-total-strip">

              <span>{{ t('orcamentos.editor.totalPreview') }}</span>

              <strong>{{ formatMoney(totalValor) }}</strong>

            </div>

          </section>



          <section class="orc-form-section">

            <header class="orc-form-section__head">

              <div class="orc-form-section__icon orc-form-section__icon--terms">

                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>

              </div>

              <div>

                <h2>{{ t('orcamentos.editor.sectionTerms') }}</h2>

                <p>{{ t('orcamentos.editor.sectionTermsSub') }}</p>

              </div>

            </header>

            <div class="orc-form-grid">

              <label class="orc-form-field orc-form-field--full">

                <span>{{ t('orcamentos.editor.infoGerais') }}</span>

                <textarea v-model="form.informacoesGerais" rows="4" :placeholder="t('orcamentos.config.informacoesPadraoPh')" />

              </label>

              <label class="orc-form-field orc-form-field--full">

                <span>{{ t('orcamentos.editor.condicoes') }}</span>

                <textarea v-model="form.condicoesPagamento" rows="4" :placeholder="t('orcamentos.config.condicoesPadraoPh')" />

              </label>

            </div>

          </section>

        </div>



        <aside class="orc-preview-column">

          <div class="orc-preview-panel">

            <header class="orc-preview-panel__head">

              <div>

                <h2>{{ t('orcamentos.editor.preview') }}</h2>

                <p>{{ t('orcamentos.editor.previewHint') }}</p>

              </div>

              <span class="orc-preview-live">

                <span class="orc-preview-live__dot" />

                {{ t('orcamentos.editor.previewLive') }}

              </span>

            </header>

            <div ref="previewPaperRef" class="orc-preview-paper">

              <div v-if="previewLoading" class="orc-preview-loading">

                <div class="orc-list-loading__spinner" />

              </div>

              <div
                v-show="!previewLoading"
                class="orc-preview-scale-host"
                :style="previewHostStyle"
              >
                <iframe
                  ref="previewFrameRef"
                  class="orc-preview-frame"
                  :style="previewFrameStyle"
                  :srcdoc="previewHtml"
                  title="preview"
                  @load="resizePreviewFrame"
                />
              </div>

            </div>

            <div v-if="publishedUrl" class="orc-published-box" role="status">

              <div class="orc-published-box__accent" aria-hidden="true" />

              <div class="orc-published-box__inner">

                <header class="orc-published-box__head">

                  <div class="orc-published-box__icon" aria-hidden="true">

                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">

                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />

                    </svg>

                  </div>

                  <div class="orc-published-box__titles">

                    <h3>{{ t('orcamentos.editor.linkReadyTitle') }}</h3>

                    <p>{{ t('orcamentos.editor.linkReadySub') }}</p>

                  </div>

                </header>



                <div class="orc-published-box__url">

                  <span class="orc-published-box__url-label">{{ t('orcamentos.editor.publicLink') }}</span>

                  <div class="orc-published-box__url-row">

                    <input

                      :value="publishedUrl"

                      readonly

                      class="orc-published-box__input"

                      @focus="($event.target).select()"

                    />

                    <button

                      type="button"

                      class="orc-published-box__copy"

                      :class="{ 'orc-published-box__copy--done': linkCopied }"

                      :title="t('orcamentos.actions.copyLink')"

                      @click="copiar(publishedUrl)"

                    >

                      <svg v-if="!linkCopied" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                        <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />

                      </svg>

                      <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">

                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />

                      </svg>

                      <span>{{ linkCopied ? t('orcamentos.list.copied') : t('orcamentos.actions.copyLink') }}</span>

                    </button>

                  </div>

                </div>



                <div class="orc-published-box__actions">

                  <a

                    :href="publishedUrl"

                    target="_blank"

                    rel="noopener noreferrer"

                    class="orc-btn orc-btn--ghost orc-published-box__open"

                  >

                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">

                      <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />

                    </svg>

                    {{ t('orcamentos.editor.openLink') }}

                  </a>

                  <button

                    v-if="leadId && whatsConnected"

                    type="button"

                    class="orc-btn orc-btn--whatsapp orc-published-box__wa"

                    @click="enviarWhatsapp"

                  >

                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">

                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />

                    </svg>

                    {{ t('orcamentos.actions.sendWhatsapp') }}

                  </button>

                </div>

              </div>

            </div>

          </div>

        </aside>

      </div>

    </div>

  </div>

</template>



<script setup>

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'

import { useRoute, useRouter } from 'vue-router'

import { useI18n } from 'vue-i18n'

import api, { postWhatsAppSend } from '@/services/api'
import Swal from 'sweetalert2'

import { emptyOrcamentoForm, formatOrcamentoMoney, patchOrcamentoHtmlMedia } from '@/utils/orcamentoUtils'
import { buildOrcCatalogRemoveSwalHtml, ORC_CATALOG_REMOVE_SWAL_CLASS } from '@/utils/orcamentoCatalogRemoveSwal'
import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'

import '@/assets/styles/workspace-orcamentos.css'



const route = useRoute()

const router = useRouter()

const { t } = useI18n()

const { currentWorkspace } = useGlobalWorkspaces()

const workspaceFotoRaw = computed(() => String(currentWorkspace.value?.fotoWorkspace || '').trim())

const workspaceId = computed(() => Number(route.params.id) || null)

const orcamentoId = computed(() => route.params.orcamentoId === 'novo' ? null : Number(route.params.orcamentoId))

const isNew = computed(() => !orcamentoId.value)

const leadId = computed(() => {

  const q = route.query.leadId

  return q ? Number(q) : form.value.leadId

})



const form = ref(emptyOrcamentoForm())

const templates = ref([])

const catalogOpen = ref(false)
const catalogPickerRef = ref(null)
const catalogDeletingId = ref(null)

const PREVIEW_DOC_WIDTH = 780

const previewHtmlRaw = ref('')
const previewHtml = computed(() =>
  patchOrcamentoHtmlMedia(previewHtmlRaw.value, workspaceFotoRaw.value)
)

const previewLoading = ref(false)

const previewPaperRef = ref(null)

const previewFrameRef = ref(null)

const previewContentHeight = ref(720)

const previewScale = ref(0.58)

let previewResizeObserver = null

const saving = ref(false)

const publishing = ref(false)

const publishedUrl = ref('')

const linkCopied = ref(false)

const whatsConnected = ref(false)

let linkCopiedTimer = null

const leadInfo = ref(null)

let previewTimer = null



const formatMoney = formatOrcamentoMoney

const totalValor = computed(() =>

  form.value.itens.reduce((s, i) => s + (Number(i.valor) || 0), 0)

)

const previewScaledHeight = computed(() =>

  Math.ceil(previewContentHeight.value * previewScale.value)

)

const previewHostStyle = computed(() => ({

  height: `${previewScaledHeight.value}px`

}))

const previewFrameStyle = computed(() => ({

  width: `${PREVIEW_DOC_WIDTH}px`,

  height: `${previewContentHeight.value}px`,

  transform: `scale(${previewScale.value})`,

  transformOrigin: 'top center'

}))



function updatePreviewScale () {

  const paper = previewPaperRef.value

  if (!paper) return

  const pad = 28

  const w = Math.max(200, paper.clientWidth - pad)

  previewScale.value = Math.min(1, Math.max(0.42, w / PREVIEW_DOC_WIDTH))

}



function resizePreviewFrame () {

  const iframe = previewFrameRef.value

  if (!iframe?.contentDocument) return

  try {

    const doc = iframe.contentDocument

    const h = Math.max(

      doc.documentElement?.scrollHeight || 0,

      doc.body?.scrollHeight || 0,

      360

    )

    previewContentHeight.value = h + 8

    updatePreviewScale()

  } catch {

    /* srcdoc same-origin */

  }

}



function bumpValidadeDias (delta) {
  const current = Number(form.value.validadeDias) || 15
  form.value.validadeDias = Math.min(365, Math.max(1, current + delta))
}

function payloadFromForm () {

  return {

    workspaceId: workspaceId.value,

    leadId: leadId.value || form.value.leadId || null,

    titulo: form.value.titulo,

    informacoesGerais: form.value.informacoesGerais,

    condicoesPagamento: form.value.condicoesPagamento,

    validadeDias: form.value.validadeDias,

    itens: form.value.itens.map((it, i) => ({

      nome: it.nome,

      descricao: it.descricao,

      valor: Number(it.valor) || 0,

      ordem: i

    }))

  }

}



async function loadSettings () {

  const { data } = await api.get(`/workspace-config/${workspaceId.value}/orcamento-settings`)

  if (isNew.value) {

    form.value.informacoesGerais = data?.informacoesGeraisPadrao || ''

    form.value.condicoesPagamento = data?.condicoesPagamentoPadrao || ''

    form.value.validadeDias = data?.validadeDiasPadrao ?? 15

  }

}



async function loadTemplates () {

  const { data } = await api.get(`/workspace-config/${workspaceId.value}/orcamento-servicos`)

  templates.value = Array.isArray(data) ? data : []

}



async function loadLeadInfo () {

  const id = leadId.value

  if (!id) { leadInfo.value = null; return }

  try {

    const { data } = await api.get(`/leads/${id}`)

    leadInfo.value = data

    form.value.leadId = id

  } catch {

    leadInfo.value = null

  }

}



async function loadOrcamento () {

  if (!orcamentoId.value) return

  const { data } = await api.get(`/orcamentos/${orcamentoId.value}`, { params: { workspaceId: workspaceId.value } })

  form.value = {

    titulo: data.titulo || '',

    informacoesGerais: data.informacoesGerais || '',

    condicoesPagamento: data.condicoesPagamento || '',

    validadeDias: data.validadeDias ?? 15,

    leadId: data.leadId,

    itens: (data.itens?.length ? data.itens : [{ nome: '', descricao: '', valor: 0 }]).map(it => ({

      nome: it.nome, descricao: it.descricao, valor: Number(it.valor) || 0

    }))

  }

  if (data.publicUrl) publishedUrl.value = data.publicUrl

  if (data.leadId) await loadLeadInfo()

  await refreshPreview()

}



async function refreshPreview () {

  clearTimeout(previewTimer)

  previewTimer = setTimeout(async () => {

    previewLoading.value = true

    try {

      const { data } = await api.post('/orcamentos/preview', payloadFromForm())

      previewHtmlRaw.value = data?.html || ''

    } catch {

      previewHtmlRaw.value = '<html><body style="font-family:sans-serif;padding:24px;color:#64748b">Preview indisponível</body></html>'

    } finally {

      previewLoading.value = false

      await nextTick()

      resizePreviewFrame()

    }

  }, 350)

}

watch(previewHtml, () => {

  nextTick(() => resizePreviewFrame())

})



function addItem () {

  form.value.itens.push({ nome: '', descricao: '', valor: 0 })

  refreshPreview()

}



function removeItem (idx) {

  form.value.itens.splice(idx, 1)

  refreshPreview()

}



function toggleCatalogPicker () {
  catalogOpen.value = !catalogOpen.value
}

function closeCatalogPicker () {
  catalogOpen.value = false
}

function onCatalogPickerOutside (event) {
  const root = catalogPickerRef.value
  if (!root || root.contains(event.target)) return
  closeCatalogPicker()
}

function pickTemplate (tpl) {
  if (!tpl) return
  form.value.itens.push({
    nome: tpl.nome,
    descricao: tpl.descricao || '',
    valor: Number(tpl.valor) || 0
  })
  closeCatalogPicker()
  refreshPreview()
}

async function removerDoCatalogo (tpl) {
  if (!tpl?.id || catalogDeletingId.value || !workspaceId.value) return

  const result = await Swal.fire({
    html: buildOrcCatalogRemoveSwalHtml({
      serviceName: tpl.nome || t('orcamentos.list.untitled'),
      labels: {
        title: t('orcamentos.editor.removeFromCatalogTitle'),
        subtitle: t('orcamentos.editor.removeFromCatalogSubtitle'),
        serviceLabel: t('orcamentos.editor.removeFromCatalogServiceLabel'),
        hint: t('orcamentos.editor.removeFromCatalogHint')
      }
    }),
    showConfirmButton: true,
    showCancelButton: true,
    showCloseButton: true,
    focusConfirm: false,
    reverseButtons: true,
    buttonsStyling: false,
    customClass: ORC_CATALOG_REMOVE_SWAL_CLASS,
    confirmButtonText: t('common.delete'),
    cancelButtonText: t('common.cancel')
  })

  if (!result.isConfirmed) return

  catalogDeletingId.value = tpl.id
  try {
    await api.delete(`/workspace-config/${workspaceId.value}/orcamento-servicos/${tpl.id}`)
    templates.value = templates.value.filter(item => item.id !== tpl.id)
    if (!templates.value.length) closeCatalogPicker()
  } catch (e) {
    const errMsg = e.response?.data?.error || e.message || t('orcamentos.editor.removeFromCatalogError')
    await Swal.fire({
      title: t('integracao.swal.error'),
      text: errMsg,
      icon: 'error'
    })
  } finally {
    catalogDeletingId.value = null
  }
}



async function salvarNoCatalogo (item) {

  if (!item.nome?.trim()) return

  await api.post(`/workspace-config/${workspaceId.value}/orcamento-servicos`, {

    nome: item.nome,

    descricao: item.descricao,

    valor: Number(item.valor) || 0

  })

  await loadTemplates()

}



async function salvar () {

  saving.value = true

  try {

    const payload = payloadFromForm()

    if (isNew.value) {

      const { data } = await api.post('/orcamentos', payload)

      await router.replace(`/workspace/${workspaceId.value}/orcamentos/${data.id}`)

      return data.id

    }

    await api.put(`/orcamentos/${orcamentoId.value}`, payload, { params: { workspaceId: workspaceId.value } })

    await refreshPreview()

    return orcamentoId.value

  } finally {

    saving.value = false

  }

}



async function publicar () {

  publishing.value = true

  try {

    const id = await salvar()

    const targetId = id || orcamentoId.value

    if (!targetId) return

    const { data } = await api.post(`/orcamentos/${targetId}/publicar`, null, { params: { workspaceId: workspaceId.value } })

    publishedUrl.value = data.publicUrl || ''

    previewHtmlRaw.value = data.snapshotHtml || previewHtmlRaw.value

  } finally {

    publishing.value = false

  }

}



async function copiar (url) {

  try {

    await navigator.clipboard.writeText(url)

    linkCopied.value = true

    clearTimeout(linkCopiedTimer)

    linkCopiedTimer = setTimeout(() => { linkCopied.value = false }, 2200)

  } catch { /* ignore */ }

}



async function enviarWhatsapp () {

  if (!leadId.value || !publishedUrl.value) return

  await postWhatsAppSend(`/whatsapp/workspace/${workspaceId.value}/send`, {

    leadId: leadId.value,

    message: `${t('orcamentos.whatsappMessage')}\n${publishedUrl.value}`

  })

}



async function loadWhatsapp () {

  try {

    const { data } = await api.get(`/whatsapp/workspace/${workspaceId.value}`)

    whatsConnected.value = !!data?.connected

  } catch { whatsConnected.value = false }

}



async function init () {

  if (!workspaceId.value) return

  form.value.leadId = route.query.leadId ? Number(route.query.leadId) : null

  await Promise.all([loadSettings(), loadTemplates(), loadWhatsapp(), loadLeadInfo()])

  if (!isNew.value) await loadOrcamento()

  else await refreshPreview()

}



onMounted(init)

onMounted(() => {

  nextTick(() => {

    previewResizeObserver = new ResizeObserver(() => updatePreviewScale())

    if (previewPaperRef.value) previewResizeObserver.observe(previewPaperRef.value)

    updatePreviewScale()

  })

})

onMounted(() => {
  document.addEventListener('click', onCatalogPickerOutside)
  document.addEventListener('keydown', onCatalogPickerKeydown)
})

onUnmounted(() => {

  previewResizeObserver?.disconnect()

  previewResizeObserver = null

  clearTimeout(previewTimer)

  clearTimeout(linkCopiedTimer)

  document.removeEventListener('click', onCatalogPickerOutside)
  document.removeEventListener('keydown', onCatalogPickerKeydown)

})

function onCatalogPickerKeydown (event) {
  if (event.key === 'Escape') closeCatalogPicker()
}

watch(() => route.fullPath, init)

watch(form, refreshPreview, { deep: true })

</script>


